<template>
  <v-container>
    <div class="d-flex">
      <div class="ma-1 flex-1">
        <v-text-field
          v-model="speakerId"
          label="speakerId"
        />
        <v-select
          v-model="speakerId"
          label="speakerId"
          :items="speakerIds"
        />
        <v-textarea
          v-model="text"
          label="text"
        />
        <v-btn @click="testVoice">
          Submit
        </v-btn>
      </div>
      <div class="ma-1 flex-1">
        <div>
          <v-text-field
            v-model="pitch"
            label="pitch"
            type="text"
          />
        </div>
        <div>
          <v-text-field
            v-model="rate"
            label="rate"
            type="text"
          />
        </div>

        <v-btn
          v-for="(s, idx) in synths"
          :key="idx"
          block
          class="mb-2"
          @click="play(s.buf)"
        >
          Play again {{ s.file }} {{ s.speakerId }}
        </v-btn>
      </div>
    </div>
  </v-container>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { loadAudioBuffer } from '../../audio'
import { TtsPlayer } from '../../TtsPlayer'
import { ALL_COQUI_VCTK_SPEAKER_IDS } from '../../../../common/src/Characters'

const speakerIds = ALL_COQUI_VCTK_SPEAKER_IDS

const speakerId = ref<string>('p225')
const text = ref<string>('')

const pitch = ref<string>('1.00')
const rate = ref<string>('1.00')

const ttsPlayer = new TtsPlayer()

const synths = ref<{ speakerId: string, buf: AudioBuffer, file: string }[]>([])

const play = async (buf: AudioBuffer) => {
  await ttsPlayer.playBuffer(buf, parseFloat(pitch.value), parseFloat(rate.value))
}

const testVoice = async () => {
  const res = await fetch(`/api/_test_voice`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ text: text.value, speakerId: speakerId.value }),
  })
  const data = await res.json()
  try {
    const synth = {
      speakerId: speakerId.value,
      file: data.file,
      buf: await loadAudioBuffer('/data/test_voice/' + data.file),
    }
    synths.value.push(synth)
    play(synth.buf)
  } catch (e) {
    console.log('unable to load audio buffer', e)
    return
  }
}
</script>
